import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountService } from '../../../../../services/account.service';
import { CommonfilterService } from 'src/app/services/commonfilter.service';

@Component({
  selector: 'app-statement-bysystem',
  templateUrl: './statement-bysystem.component.html',
  styleUrls: ['./statement-bysystem.component.css']
})
export class StatementBysystemComponent implements OnInit {

  api_error: any;
  api_success: string;
  disableConfirmbtn = false;
  subscriptionType: any;
  changeSubscriptionText: string;
  subscriptionDetails: any;
  subscriptionMessage: string;
  configData: any = {};
  licSubscriptionTypeDetails: any;
  monthly: any;
  annual: any;
  stmtCreatedBySystem: any;
  constructor(private dialogRef: MatDialogRef<any>,
     @Inject(MAT_DIALOG_DATA) public data: any,
      private accountService: AccountService, private commonfilter: CommonfilterService) {

    this.commonfilter.getConfigData()
    .subscribe(res => {
     this.configData = res;
     console.log(JSON.stringify(this.configData));
     this.licSubscriptionTypeDetails = this.configData.licSubscriptionTypeDetails;
    
     });
   }

  ngOnInit() {
    this.stmtCreatedBySystem = this.data['stmtCreatedBySystem'];
   }

 onConfirm() {
  this.api_error = '';
  this.api_success = '';
  this.disableConfirmbtn = true;
  if(this.stmtCreatedBySystem){
    this.accountService.changestatementGeneration(this.data['accountId'], 'false')
    .subscribe(
      data => {
      this.api_success = 'Changed successfully';
        setTimeout(() => {
          this.dialogRef.close('reloadlist');
          }, 2000);
        },
     (error) => {
      this.api_error = error.error;
      this.disableConfirmbtn = false;
      }
    );
  }
 else{
  this.accountService.changestatementGeneration(this.data['accountId'],'true')
  .subscribe(
    data => {
    this.api_success = 'Changed successfully';
      setTimeout(() => {
        this.dialogRef.close('reloadlist');
        }, 2000);
      },
   (error) => {
    this.api_error = error.error;
    this.disableConfirmbtn = false;
    }
  );
 }

}
}
